import React from "react";
import Loading from "./Loading";

export default function LoadingOnTop() {
  return (
    <div className="loading_modal">
      <Loading />
    </div>
  );
}
